import React from "react";
import ScrollToTopOnMount from "../Components/ScrollToTop";
import Footer from "../UI/Footer/Footer";
import NavBar from "../UI/NavBar/NavBar";
import ResponsiveError from "../ErrorPage/ResponsiveError";
import ContentSection from "./ContentSection/Main";
import TopSection from "./TopSection/Main";
import "../UI/Grid.css";

const Platform = () => {
  const phoneScreenWidth = 1189;
  const isPhoneScreen = window.innerWidth < phoneScreenWidth;

  return (
    <div>
      <ScrollToTopOnMount />
      <NavBar />
      {isPhoneScreen ? (
        <ResponsiveError />
      ) : (
        <>
          <TopSection />
          <ContentSection />
        </>
      )}
      <Footer />
    </div>
  );
};

export default Platform;
